<template>
  <div class="w-screen flex flex-col bg">
    <div class="flex-grow flex flex-col">
      <div class="flex flex-grow">
        <div class="w-1/4 p-4 overflow-y-auto" style="height:90vh">
          <div v-for="(grad,i) of gradients" :key="i" @click="selectGradient(grad)">
            <div class="h-32 w-full rounded-t" :style="{background:grad.style}"></div>
            <div class="text-xs p-1 bg-white rounded-b mb-1 flex items-center">
              <div class="flex-grow flex">
                <div>{{grad.name}}</div>
                <div class="text-red-600 px-1" @click="grad.remove()">delete</div>
              </div>
              <div v-for="(item,i) of grad.colors" :key="i" class="ml-1">
                <VColorButton :styleColor="item.color" />
              </div>
            </div>
          </div>
        </div>
        <div class="w-2/4 flex justify-center p-24 bg-white" style="height:90vh">
          <div class="w-full shadow-md rounded" :style="{background:gradient.style}"></div>
        </div>
        <div class="w-1/4 text-center p-4">
          <div class="w-full flex justify-center">
            <ColorPicker
              :width="300"
              :height="300"
              :disabled="false"
              :startColor="color"
              @colorChange="(c)=>this.color = c"
            ></ColorPicker>
          </div>
          <div class="flex justify-center">
            <button
              class="bg-teal-600 text-white text-xs px-3 py-1 my-2 mr-2"
              @click="onAddColor()"
            >ADD</button>
            <button
              class="bg-teal-600 text-white text-xs px-3 py-1 my-2 flex items-center"
              @click="resetGradient()"
            >
              <RefreshCwIcon size="12" />
              <div class="ml-2">Reset</div>
            </button>
          </div>
          <div class="text-left p-2">
            <div class="flex justify-evenly items-start">
              <VInput
                type="text"
                label="Name"
                :value="gradient.name"
                :max="360"
                v-model="gradient.name"
              />
              <div>
                <VInput
                  type="number"
                  label="Degree"
                  :value="gradient.degree"
                  v-model="gradient.degree"
                />
                <vue-slider v-model="gradient.degree" v-bind="{max: 360}"></vue-slider>
              </div>
              <div class="self-center">
                <VButton
                  v-if="gradient.doc == null"
                  :disabled="!gradient.name.trim()"
                  label="Save"
                  @click="saveGradient()"
                />
                <VButton v-else label="Update" @click="updateGradient()" />
              </div>
            </div>
            <div style="height:40vh" class="overflow-y-auto mt-6">
              <div v-for="(item, i) of gradient.colors" :key="i">
                <div class="flex items-center justify-center my-1">
                  <div class="mr-2">
                    <VColorButton :styleColor="item.color" />
                  </div>
                  <div>
                    <input
                      type="text"
                      class="form-control-dark"
                      :value="item.color"
                      @change="onChangeColor(item, $event)"
                    />
                  </div>
                  <div>
                    <button
                      class="bg-red-600 text-white text-xs px-3 py-1 ml-2"
                      @click="onRemoveColor(item)"
                    >DELETE</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { UUID, UiSelect, UiTabs } from "@/util";
import { mapState, mapGetters, mapActions } from "vuex";
import firebase, { firestore } from "firebase";
import { AppService, Gradient, GradientColor } from "../../store";
import { Component } from "../../store/models/component.model";
import ColorPicker from "vue-color-picker-wheel";
import Vue from "vue";

export default {
  name: "GradientCreator",
  components: {
    ColorPicker
  },
  data() {
    return {
      gradient: new Gradient(),
      color: "#4fd1c5"
    };
  },
  mounted() {
    this.onAddColor();
    this.gradient.addColor(new GradientColor({ color: "#63b3ed" }));
  },
  computed: {
     ...mapState(["gradients"])
  },
  methods: {
    onAddColor() {
      this.gradient.addColor(new GradientColor({ color: this.color }));
    },
    onRemoveColor(item) {
      this.gradient.removeColor(item);
    },
    onChangeColor(item, { target }) {
      this.gradient.changeColor(item, target.value);
    },
    saveGradient() {
      this.gradient.create().then(resp => {
        console.log(resp);
      });
    },
    updateGradient() {
      this.gradient.update();
    },
    selectGradient(item) {
      this.gradient = item;
    },
    resetGradient() {
      this.gradient = new Gradient();
      this.onAddColor();
      this.onAddColor();
    }
  }
};
</script>

<style scoped>
.grad {
  background: linear-gradient(90deg, red 0%, blue 50%, green 100%);
}
</style>